module.exports = __webpack_public_path__ + "img/behandel1.45863dcc.jpeg";